<template>
    <breadcrumbs-root></breadcrumbs-root>
    <div class="ConfiguratorPaths">
        <div class="ConfiguratorPaths-frame u-frameMd">
            <h2 class="u-secondHeading">{{title}}</h2>
            <div class="ConfiguratorPaths-perex">
                <div v-html="text"></div>
                <figure v-if="map && map.length" tooltip="Naše oblast působení. Pokud nejste z vybraného okresu, zavolejte nám." position="bottom">
                    <img :src="map" width="303" height="217" alt="mapa" />
                </figure>
            </div>
        </div>
        <div class="ConfiguratorPaths-bottom" :style="{backgroundImage: `url(${image})`}">
            <div class="ConfiguratorPaths-frame u-frameMd">
                <h2 class="u-secondHeading u-textCenter">Chci řešit</h2>
                <BoxLinks :items="paths" />
            </div>
        </div>
    </div>
</template>

<script>
import BoxLinks from './BoxLinks.vue';
import BreadcrumbsRoot from './BreadcrumbsRoot.vue';

export default {
    components: {BoxLinks, BreadcrumbsRoot},
    props: {
        paths: Object,
        title: String,
        text: String,
        image: String,
        map: String
    }
}
</script>

<style lang="scss" scoped>
    .ConfiguratorPaths {
        &-bottom {
            background-repeat: no-repeat;
            background-position: center center;
            position: relative;
            padding-bottom: 4rem;
            min-height: 730px;
            @media(max-width: 550px) {
                min-height: 600px;
            }

            &:before {
                content: ' ';
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                background: linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%);
                height: 290px;
                max-height: 100%;
            }
        }

        &-frame {
            position: relative;
        }

        &-perex {
            display: flex;
            align-items: flex-start;
            gap: 2em;
            margin: 0 0 3.2em;

            @media (max-width: 680px) {
                flex-flow: column;
            }

            figure {
                margin: 0;
            }
        }
    }
</style>